<template>
  <BaseNode
    :node="node"
    :editor-errors="editorErrors"
    color="#70ad47"
  >
    <div class="AbSplitterElementNode">{{node.percent}}%</div>
  </BaseNode>
</template>

<script>
import nodeMixin from './nodeMixin'

export default {
  mixins: [nodeMixin]
}
</script>

<style lang="scss">
.AbSplitterElementNode {
  min-width: 100px;
  text-align: center;
}
</style>
